import { Link, useNavigate, useParams } from "react-router-dom";
import SideBarWrapper from "../../../components/common/SideBarWrapper";
import Navbar from "../../../layout/Navbar";
import { useEffect, useState } from "react";
import { baseURL } from "../../../utils/misc";
import useAuth from "../../../hooks/useAuth";
import HarvestingForm from "../../../components/HarvestingRecords/HarvestingForm";
import Footer from "../../../layout/Footer";
import { toast } from "react-toastify";

const EditHarvestingRecord = () => {
    const { harvestingRecordId } = useParams();
    const [harvestingRecord, setHarvestingRecord] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }
        // Fetch workflow process data when the component mounts
        const fetchData = async () => {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                }
            };

            try {
                const response = await fetch(`${baseURL}/harvestingrecords/${harvestingRecordId}`, requestOptions);

                if (response.ok) {
                    const data = await response.json();
                    setHarvestingRecord(data);
                } else {
                    console.error('Error fetching planting record data');
                }
            } catch (error) {
                console.error('Error fetching planting record data:', error);
            }
        };

        fetchData();
    }, [harvestingRecordId, navigate, user]);



    return (<>


        {/* Page wrapper start */}
        <div className="page-wrapper">

            {/* Sidebar wrapper start */}
            <SideBarWrapper />
            {/* Sidebar wrapper end */}

            {/* Page content start  */}
            <div className="page-content">

                {/* Header start */}
                <Navbar />
                {/* Header end */}

                {/* Page header start */}
                <div className="page-header">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item">{harvestingRecord && harvestingRecord && harvestingRecord.code}</li>
                        <li className="breadcrumb-item">
                            <Link to={`/harvestingrecords/crop/${harvestingRecord && harvestingRecord && harvestingRecord.cropId}`} >Harvesting Records</Link>
                        </li>
                        <li className="breadcrumb-item active">Edit</li>
                    </ol>
                    <ul className="app-actions">
                    </ul>
                </div>
                {/* Page header end */}

                {/* Main container start */}
                <div className="main-container">
                    <HarvestingForm crop={harvestingRecord && harvestingRecord.crop} harvestingRecords={harvestingRecord && harvestingRecord} />
                </div>
                {/* Main container end */}

            </div>
            {/* Page content end */}
            <Footer/>

        </div>
        {/* Page wrapper end */}
    </>);
}

export default EditHarvestingRecord;